import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};



export type AboutMe = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  aboutMeTopContentRaw?: Maybe<Scalars['JSON']>;
  topImage?: Maybe<MyImage>;
  aboutMeQuoteRaw?: Maybe<Scalars['JSON']>;
  aboutMeBottomContentRaw?: Maybe<Scalars['JSON']>;
  bottomImage?: Maybe<MyImage>;
  image?: Maybe<CloudinaryAsset>;
};

export type AboutMeFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  topImage?: Maybe<MyImageFilter>;
  bottomImage?: Maybe<MyImageFilter>;
  image?: Maybe<CloudinaryAssetFilter>;
};

export type AboutMeOrGalleryOrHomepageOrMainBlogPageOrMyProjectsOrPost = AboutMe | Gallery | Homepage | MainBlogPage | MyProjects | Post;

export type AboutMeSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  topImage?: Maybe<MyImageSorting>;
  bottomImage?: Maybe<MyImageSorting>;
  image?: Maybe<CloudinaryAssetSorting>;
};

export type Block = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Span>>>;
  style?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['String']>;
};

export type BlockOrCloudinaryImageOrInstagramPostOrMyImageOrYoutube = Block | CloudinaryImage | InstagramPost | MyImage | Youtube;

export type BlockOrImage = Block | Image;

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Boolean']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Boolean']>;
};

export type Button = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  mobileText?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  link?: Maybe<AboutMeOrGalleryOrHomepageOrMainBlogPageOrMyProjectsOrPost>;
  externalLink?: Maybe<Scalars['String']>;
};

export type ButtonFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  text?: Maybe<StringFilter>;
  mobileText?: Maybe<StringFilter>;
  linkType?: Maybe<StringFilter>;
  externalLink?: Maybe<StringFilter>;
};

export type ButtonSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  mobileText?: Maybe<SortOrder>;
  linkType?: Maybe<SortOrder>;
  externalLink?: Maybe<SortOrder>;
};

export type CloudinaryAsset = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  public_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  secure_url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  bytes?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['DateTime']>;
  derived?: Maybe<Array<Maybe<CloudinaryAssetDerived>>>;
  access_mode?: Maybe<Scalars['String']>;
  context?: Maybe<CloudinaryAssetContext>;
};

export type CloudinaryAssetContext = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  custom?: Maybe<CloudinaryAssetContextCustom>;
};

export type CloudinaryAssetContextCustom = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type CloudinaryAssetContextCustomFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  alt?: Maybe<StringFilter>;
  caption?: Maybe<StringFilter>;
};

export type CloudinaryAssetContextCustomSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  alt?: Maybe<SortOrder>;
  caption?: Maybe<SortOrder>;
};

export type CloudinaryAssetContextFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  custom?: Maybe<CloudinaryAssetContextCustomFilter>;
};

export type CloudinaryAssetContextSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  custom?: Maybe<CloudinaryAssetContextCustomSorting>;
};

export type CloudinaryAssetDerived = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  raw_transformation?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  secure_url?: Maybe<Scalars['String']>;
};

export type CloudinaryAssetDerivedFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  raw_transformation?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
  secure_url?: Maybe<StringFilter>;
};

export type CloudinaryAssetDerivedSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  raw_transformation?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  secure_url?: Maybe<SortOrder>;
};

export type CloudinaryAssetFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  public_id?: Maybe<StringFilter>;
  resource_type?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  format?: Maybe<StringFilter>;
  version?: Maybe<FloatFilter>;
  url?: Maybe<StringFilter>;
  secure_url?: Maybe<StringFilter>;
  width?: Maybe<FloatFilter>;
  height?: Maybe<FloatFilter>;
  bytes?: Maybe<FloatFilter>;
  duration?: Maybe<FloatFilter>;
  created_at?: Maybe<DatetimeFilter>;
  access_mode?: Maybe<StringFilter>;
  context?: Maybe<CloudinaryAssetContextFilter>;
};

export type CloudinaryAssetSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  public_id?: Maybe<SortOrder>;
  resource_type?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  secure_url?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  bytes?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  access_mode?: Maybe<SortOrder>;
  context?: Maybe<CloudinaryAssetContextSorting>;
};

export type CloudinaryImage = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cloudinaryImage?: Maybe<CloudinaryAsset>;
};

export type CloudinaryImageFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  cloudinaryImage?: Maybe<CloudinaryAssetFilter>;
};

export type CloudinaryImageSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  cloudinaryImage?: Maybe<CloudinaryAssetSorting>;
};

export type CrossDatasetReference = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _ref?: Maybe<Scalars['String']>;
  _weak?: Maybe<Scalars['Boolean']>;
  _dataset?: Maybe<Scalars['String']>;
  _projectId?: Maybe<Scalars['String']>;
};

export type CrossDatasetReferenceFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _ref?: Maybe<StringFilter>;
  _weak?: Maybe<BooleanFilter>;
  _dataset?: Maybe<StringFilter>;
  _projectId?: Maybe<StringFilter>;
};

export type CrossDatasetReferenceSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _ref?: Maybe<SortOrder>;
  _weak?: Maybe<SortOrder>;
  _dataset?: Maybe<SortOrder>;
  _projectId?: Maybe<SortOrder>;
};

export type Cta = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  link?: Maybe<GalleryOrMyProjectsOrPostOrServices>;
  backgroundImage?: Maybe<MinimalImage>;
  backgroundImageMobile?: Maybe<MinimalImage>;
  buttonText?: Maybe<Scalars['String']>;
};

export type CtaFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  subtitle?: Maybe<StringFilter>;
  backgroundImage?: Maybe<MinimalImageFilter>;
  backgroundImageMobile?: Maybe<MinimalImageFilter>;
  buttonText?: Maybe<StringFilter>;
};

export type CtaSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  subtitle?: Maybe<SortOrder>;
  backgroundImage?: Maybe<MinimalImageSorting>;
  backgroundImageMobile?: Maybe<MinimalImageSorting>;
  buttonText?: Maybe<SortOrder>;
};


export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Date']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Date']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Date']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Date']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Date']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Date']>;
};


export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['DateTime']>;
};

/** A Sanity document */
export type Document = {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
};

export type DocumentFilter = {
  /** All documents referencing the given document ID. */
  references?: Maybe<Scalars['ID']>;
  /** All documents that are drafts. */
  is_draft?: Maybe<Scalars['Boolean']>;
};

export type File = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
};

export type FileFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityFileAssetFilter>;
};

export type FileSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
};

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Float']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Float']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Float']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Float']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Float']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Float']>;
};

export type Gallery = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  images?: Maybe<Array<Maybe<GalleryItem>>>;
};

export type GalleryFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
};

export type GalleryItem = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<MinimalImage>;
  images?: Maybe<Array<Maybe<MyImage>>>;
};

export type GalleryItemFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  thumbnail?: Maybe<MinimalImageFilter>;
};

export type GalleryItemSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  thumbnail?: Maybe<MinimalImageSorting>;
};

export type GalleryOrMyProjects = Gallery | MyProjects;

export type GalleryOrMyProjectsOrPostOrServices = Gallery | MyProjects | Post | Services;

export type GallerySorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
};

export type Geopoint = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  alt?: Maybe<Scalars['Float']>;
};

export type GeopointFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  lat?: Maybe<FloatFilter>;
  lng?: Maybe<FloatFilter>;
  alt?: Maybe<FloatFilter>;
};

export type GeopointSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  lng?: Maybe<SortOrder>;
  alt?: Maybe<SortOrder>;
};

export type Homepage = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  aboutMeContentRaw?: Maybe<Scalars['JSON']>;
  aboutMeImage?: Maybe<MyImage>;
  desktopImage?: Maybe<MyImage>;
  mobileImage?: Maybe<MyImage>;
  categoryOrder?: Maybe<Array<Maybe<PostCategory>>>;
  topCta?: Maybe<Cta>;
  bottomCta?: Maybe<Cta>;
  featuredPosts?: Maybe<Array<Maybe<Post>>>;
};

export type HomepageFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  aboutMeImage?: Maybe<MyImageFilter>;
  desktopImage?: Maybe<MyImageFilter>;
  mobileImage?: Maybe<MyImageFilter>;
  topCta?: Maybe<CtaFilter>;
  bottomCta?: Maybe<CtaFilter>;
};

export type HomepageSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  aboutMeImage?: Maybe<MyImageSorting>;
  desktopImage?: Maybe<MyImageSorting>;
  mobileImage?: Maybe<MyImageSorting>;
  topCta?: Maybe<CtaSorting>;
  bottomCta?: Maybe<CtaSorting>;
};

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['ID']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['ID']>;
  /** Checks if the value matches the given word/words. */
  matches?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
  nin?: Maybe<Array<Scalars['ID']>>;
};

export type Image = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  hotspot?: Maybe<SanityImageHotspot>;
  crop?: Maybe<SanityImageCrop>;
};

export type ImageFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityImageAssetFilter>;
  hotspot?: Maybe<SanityImageHotspotFilter>;
  crop?: Maybe<SanityImageCropFilter>;
};

export type ImageSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  hotspot?: Maybe<SanityImageHotspotSorting>;
  crop?: Maybe<SanityImageCropSorting>;
};

export type InstagramPost = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Visit an Instagram post in a browser and copy the URL. */
  url?: Maybe<Scalars['String']>;
};

export type InstagramPostFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type InstagramPostSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Int']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Int']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Int']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Int']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Int']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Int']>;
};


export type KeyValue = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type KeyValueFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  key?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type KeyValueSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type LocaleBlockContent = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  enRaw?: Maybe<Scalars['JSON']>;
  esRaw?: Maybe<Scalars['JSON']>;
  nbRaw?: Maybe<Scalars['JSON']>;
};

export type LocaleBlockContentFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
};

export type LocaleBlockContentSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
};

export type LocaleString = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  nb?: Maybe<Scalars['String']>;
};

export type LocaleStringFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  en?: Maybe<StringFilter>;
  es?: Maybe<StringFilter>;
  nb?: Maybe<StringFilter>;
};

export type LocaleStringSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  en?: Maybe<SortOrder>;
  es?: Maybe<SortOrder>;
  nb?: Maybe<SortOrder>;
};

export type LocaleText = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  nb?: Maybe<Scalars['String']>;
};

export type LocaleTextFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  en?: Maybe<StringFilter>;
  es?: Maybe<StringFilter>;
  nb?: Maybe<StringFilter>;
};

export type LocaleTextSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  en?: Maybe<SortOrder>;
  es?: Maybe<SortOrder>;
  nb?: Maybe<SortOrder>;
};

export type MainBlogPage = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  featuredPosts?: Maybe<Array<Maybe<Post>>>;
};

export type MainBlogPageFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type MainBlogPageSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
};

export type MinimalImage = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  hotspot?: Maybe<SanityImageHotspot>;
  crop?: Maybe<SanityImageCrop>;
  alt?: Maybe<Scalars['String']>;
};

export type MinimalImageFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityImageAssetFilter>;
  hotspot?: Maybe<SanityImageHotspotFilter>;
  crop?: Maybe<SanityImageCropFilter>;
  alt?: Maybe<StringFilter>;
};

export type MinimalImageSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  hotspot?: Maybe<SanityImageHotspotSorting>;
  crop?: Maybe<SanityImageCropSorting>;
  alt?: Maybe<SortOrder>;
};

export type MyImage = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  hotspot?: Maybe<SanityImageHotspot>;
  crop?: Maybe<SanityImageCrop>;
  alt?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  /** Portrait, Landscape or Square */
  layout?: Maybe<Scalars['String']>;
};

export type MyImageFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityImageAssetFilter>;
  hotspot?: Maybe<SanityImageHotspotFilter>;
  crop?: Maybe<SanityImageCropFilter>;
  alt?: Maybe<StringFilter>;
  caption?: Maybe<StringFilter>;
  layout?: Maybe<StringFilter>;
};

export type MyImageSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  hotspot?: Maybe<SanityImageHotspotSorting>;
  crop?: Maybe<SanityImageCropSorting>;
  alt?: Maybe<SortOrder>;
  caption?: Maybe<SortOrder>;
  layout?: Maybe<SortOrder>;
};

export type MyProjects = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  properties?: Maybe<Array<Maybe<KeyValue>>>;
  topImage?: Maybe<MinimalImage>;
  topTextRaw?: Maybe<Scalars['JSON']>;
  middleTopTextRaw?: Maybe<Scalars['JSON']>;
  middleTopImage?: Maybe<MinimalImage>;
  middleBottomTextRaw?: Maybe<Scalars['JSON']>;
  middleBottomImage?: Maybe<MinimalImage>;
  imagesRow?: Maybe<Array<Maybe<MinimalImage>>>;
  bottomTextRaw?: Maybe<Scalars['JSON']>;
  gallery?: Maybe<Array<Maybe<MinimalImage>>>;
};

export type MyProjectsConfig = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  navigation?: Maybe<Array<Maybe<NavigationItem>>>;
};

export type MyProjectsConfigFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
};

export type MyProjectsConfigSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
};

export type MyProjectsFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  topImage?: Maybe<MinimalImageFilter>;
  middleTopImage?: Maybe<MinimalImageFilter>;
  middleBottomImage?: Maybe<MinimalImageFilter>;
};

export type MyProjectsSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  topImage?: Maybe<MinimalImageSorting>;
  middleTopImage?: Maybe<MinimalImageSorting>;
  middleBottomImage?: Maybe<MinimalImageSorting>;
};

export type NavigationItem = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  link?: Maybe<GalleryOrMyProjects>;
};

export type NavigationItemFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type NavigationItemSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
};

export type Post = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  /** This text will appear in search results pages */
  description?: Maybe<Scalars['String']>;
  /** This text will appear in main blog page */
  summary?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  mainPhoto?: Maybe<MyImage>;
  category?: Maybe<PostCategory>;
  tags?: Maybe<Array<Maybe<PostTag>>>;
  featuredPosts?: Maybe<Array<Maybe<Post>>>;
  postContentRaw?: Maybe<Scalars['JSON']>;
};

export type PostCategory = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
};

export type PostCategoryFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
};

export type PostCategorySorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
};

export type PostFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  description?: Maybe<StringFilter>;
  summary?: Maybe<StringFilter>;
  date?: Maybe<DateFilter>;
  mainPhoto?: Maybe<MyImageFilter>;
  category?: Maybe<PostCategoryFilter>;
};

export type PostSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  description?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  mainPhoto?: Maybe<MyImageSorting>;
};

export type PostTag = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
};

export type PostTagFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
};

export type PostTagSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
};

export type RootQuery = {
  Document?: Maybe<Document>;
  AboutMe?: Maybe<AboutMe>;
  Post?: Maybe<Post>;
  PostCategory?: Maybe<PostCategory>;
  PostTag?: Maybe<PostTag>;
  Homepage?: Maybe<Homepage>;
  MainBlogPage?: Maybe<MainBlogPage>;
  Gallery?: Maybe<Gallery>;
  MyProjects?: Maybe<MyProjects>;
  MyProjectsConfig?: Maybe<MyProjectsConfig>;
  Services?: Maybe<Services>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  allAboutMe: Array<AboutMe>;
  allPost: Array<Post>;
  allPostCategory: Array<PostCategory>;
  allPostTag: Array<PostTag>;
  allHomepage: Array<Homepage>;
  allMainBlogPage: Array<MainBlogPage>;
  allGallery: Array<Gallery>;
  allMyProjects: Array<MyProjects>;
  allMyProjectsConfig: Array<MyProjectsConfig>;
  allServices: Array<Services>;
  allSanityImageAsset: Array<SanityImageAsset>;
  allSanityFileAsset: Array<SanityFileAsset>;
};


export type RootQuery_DocumentArgs = {
  id: Scalars['ID'];
};


export type RootQuery_AboutMeArgs = {
  id: Scalars['ID'];
};


export type RootQuery_PostArgs = {
  id: Scalars['ID'];
};


export type RootQuery_PostCategoryArgs = {
  id: Scalars['ID'];
};


export type RootQuery_PostTagArgs = {
  id: Scalars['ID'];
};


export type RootQuery_HomepageArgs = {
  id: Scalars['ID'];
};


export type RootQuery_MainBlogPageArgs = {
  id: Scalars['ID'];
};


export type RootQuery_GalleryArgs = {
  id: Scalars['ID'];
};


export type RootQuery_MyProjectsArgs = {
  id: Scalars['ID'];
};


export type RootQuery_MyProjectsConfigArgs = {
  id: Scalars['ID'];
};


export type RootQuery_ServicesArgs = {
  id: Scalars['ID'];
};


export type RootQuery_SanityImageAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuery_SanityFileAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuery_AllAboutMeArgs = {
  where?: Maybe<AboutMeFilter>;
  sort?: Maybe<Array<AboutMeSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllPostArgs = {
  where?: Maybe<PostFilter>;
  sort?: Maybe<Array<PostSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllPostCategoryArgs = {
  where?: Maybe<PostCategoryFilter>;
  sort?: Maybe<Array<PostCategorySorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllPostTagArgs = {
  where?: Maybe<PostTagFilter>;
  sort?: Maybe<Array<PostTagSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllHomepageArgs = {
  where?: Maybe<HomepageFilter>;
  sort?: Maybe<Array<HomepageSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllMainBlogPageArgs = {
  where?: Maybe<MainBlogPageFilter>;
  sort?: Maybe<Array<MainBlogPageSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllGalleryArgs = {
  where?: Maybe<GalleryFilter>;
  sort?: Maybe<Array<GallerySorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllMyProjectsArgs = {
  where?: Maybe<MyProjectsFilter>;
  sort?: Maybe<Array<MyProjectsSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllMyProjectsConfigArgs = {
  where?: Maybe<MyProjectsConfigFilter>;
  sort?: Maybe<Array<MyProjectsConfigSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllServicesArgs = {
  where?: Maybe<ServicesFilter>;
  sort?: Maybe<Array<ServicesSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllSanityImageAssetArgs = {
  where?: Maybe<SanityImageAssetFilter>;
  sort?: Maybe<Array<SanityImageAssetSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type RootQuery_AllSanityFileAssetArgs = {
  where?: Maybe<SanityFileAssetFilter>;
  sort?: Maybe<Array<SanityFileAssetSorting>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SanityAssetSourceData = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']>;
};

export type SanityAssetSourceDataFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type SanityAssetSourceDataSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type SanityFileAsset = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  altText?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  assetId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  source?: Maybe<SanityAssetSourceData>;
};

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  originalFilename?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  altText?: Maybe<StringFilter>;
  sha1hash?: Maybe<StringFilter>;
  extension?: Maybe<StringFilter>;
  mimeType?: Maybe<StringFilter>;
  size?: Maybe<FloatFilter>;
  assetId?: Maybe<StringFilter>;
  path?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
  source?: Maybe<SanityAssetSourceDataFilter>;
};

export type SanityFileAssetSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  originalFilename?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  altText?: Maybe<SortOrder>;
  sha1hash?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  mimeType?: Maybe<SortOrder>;
  size?: Maybe<SortOrder>;
  assetId?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  source?: Maybe<SanityAssetSourceDataSorting>;
};

export type SanityImageAsset = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  altText?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  assetId?: Maybe<Scalars['String']>;
  uploadId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  metadata?: Maybe<SanityImageMetadata>;
  source?: Maybe<SanityAssetSourceData>;
};

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  originalFilename?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  altText?: Maybe<StringFilter>;
  sha1hash?: Maybe<StringFilter>;
  extension?: Maybe<StringFilter>;
  mimeType?: Maybe<StringFilter>;
  size?: Maybe<FloatFilter>;
  assetId?: Maybe<StringFilter>;
  uploadId?: Maybe<StringFilter>;
  path?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
  metadata?: Maybe<SanityImageMetadataFilter>;
  source?: Maybe<SanityAssetSourceDataFilter>;
};

export type SanityImageAssetSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  originalFilename?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  altText?: Maybe<SortOrder>;
  sha1hash?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  mimeType?: Maybe<SortOrder>;
  size?: Maybe<SortOrder>;
  assetId?: Maybe<SortOrder>;
  uploadId?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  metadata?: Maybe<SanityImageMetadataSorting>;
  source?: Maybe<SanityAssetSourceDataSorting>;
};

export type SanityImageCrop = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Float']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
};

export type SanityImageCropFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  top?: Maybe<FloatFilter>;
  bottom?: Maybe<FloatFilter>;
  left?: Maybe<FloatFilter>;
  right?: Maybe<FloatFilter>;
};

export type SanityImageCropSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  top?: Maybe<SortOrder>;
  bottom?: Maybe<SortOrder>;
  left?: Maybe<SortOrder>;
  right?: Maybe<SortOrder>;
};

export type SanityImageDimensions = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  aspectRatio?: Maybe<Scalars['Float']>;
};

export type SanityImageDimensionsFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  height?: Maybe<FloatFilter>;
  width?: Maybe<FloatFilter>;
  aspectRatio?: Maybe<FloatFilter>;
};

export type SanityImageDimensionsSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
  aspectRatio?: Maybe<SortOrder>;
};

export type SanityImageHotspot = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspotFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  x?: Maybe<FloatFilter>;
  y?: Maybe<FloatFilter>;
  height?: Maybe<FloatFilter>;
  width?: Maybe<FloatFilter>;
};

export type SanityImageHotspotSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  x?: Maybe<SortOrder>;
  y?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type SanityImageMetadata = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  location?: Maybe<Geopoint>;
  dimensions?: Maybe<SanityImageDimensions>;
  palette?: Maybe<SanityImagePalette>;
  lqip?: Maybe<Scalars['String']>;
  blurHash?: Maybe<Scalars['String']>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  isOpaque?: Maybe<Scalars['Boolean']>;
};

export type SanityImageMetadataFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  location?: Maybe<GeopointFilter>;
  dimensions?: Maybe<SanityImageDimensionsFilter>;
  palette?: Maybe<SanityImagePaletteFilter>;
  lqip?: Maybe<StringFilter>;
  blurHash?: Maybe<StringFilter>;
  hasAlpha?: Maybe<BooleanFilter>;
  isOpaque?: Maybe<BooleanFilter>;
};

export type SanityImageMetadataSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  location?: Maybe<GeopointSorting>;
  dimensions?: Maybe<SanityImageDimensionsSorting>;
  palette?: Maybe<SanityImagePaletteSorting>;
  lqip?: Maybe<SortOrder>;
  blurHash?: Maybe<SortOrder>;
  hasAlpha?: Maybe<SortOrder>;
  isOpaque?: Maybe<SortOrder>;
};

export type SanityImagePalette = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
};

export type SanityImagePaletteFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  darkMuted?: Maybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: Maybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: Maybe<SanityImagePaletteSwatchFilter>;
  vibrant?: Maybe<SanityImagePaletteSwatchFilter>;
  dominant?: Maybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: Maybe<SanityImagePaletteSwatchFilter>;
  muted?: Maybe<SanityImagePaletteSwatchFilter>;
};

export type SanityImagePaletteSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  darkMuted?: Maybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: Maybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: Maybe<SanityImagePaletteSwatchSorting>;
  vibrant?: Maybe<SanityImagePaletteSwatchSorting>;
  dominant?: Maybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: Maybe<SanityImagePaletteSwatchSorting>;
  muted?: Maybe<SanityImagePaletteSwatchSorting>;
};

export type SanityImagePaletteSwatch = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  foreground?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type SanityImagePaletteSwatchFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  background?: Maybe<StringFilter>;
  foreground?: Maybe<StringFilter>;
  population?: Maybe<FloatFilter>;
  title?: Maybe<StringFilter>;
};

export type SanityImagePaletteSwatchSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  background?: Maybe<SortOrder>;
  foreground?: Maybe<SortOrder>;
  population?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
};

export type ServiceItem = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<MinimalImage>;
};

export type ServiceItemFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  subtitle?: Maybe<StringFilter>;
  backgroundImage?: Maybe<MinimalImageFilter>;
};

export type ServiceItemSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  subtitle?: Maybe<SortOrder>;
  backgroundImage?: Maybe<MinimalImageSorting>;
};

export type Services = Document & {
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  topTextRaw?: Maybe<Scalars['JSON']>;
  mainImage?: Maybe<MinimalImage>;
  mainImageMobile?: Maybe<MinimalImage>;
  middleTextRaw?: Maybe<Scalars['JSON']>;
  serviceItems?: Maybe<Array<Maybe<ServiceItem>>>;
  button?: Maybe<Button>;
};

export type ServicesFilter = {
  /** Apply filters on document level */
  _?: Maybe<DocumentFilter>;
  _id?: Maybe<IdFilter>;
  _type?: Maybe<StringFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  _rev?: Maybe<StringFilter>;
  _key?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  mainImage?: Maybe<MinimalImageFilter>;
  mainImageMobile?: Maybe<MinimalImageFilter>;
  button?: Maybe<ButtonFilter>;
};

export type ServicesSorting = {
  _id?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _createdAt?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  mainImage?: Maybe<MinimalImageSorting>;
  mainImageMobile?: Maybe<MinimalImageSorting>;
  button?: Maybe<ButtonSorting>;
};

export type Slug = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type SlugFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  current?: Maybe<StringFilter>;
  source?: Maybe<StringFilter>;
};

export type SlugSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  current?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
};

export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC'
}

export type Span = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['String']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['String']>;
  /** Checks if the value matches the given word/words. */
  matches?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  nin?: Maybe<Array<Scalars['String']>>;
};

export type Youtube = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type YoutubeFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type YoutubeSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type AllAboutQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAboutQuery = { allAboutMe: Array<{ aboutMeTopContentRaw?: Maybe<any>, aboutMeQuoteRaw?: Maybe<any>, aboutMeBottomContentRaw?: Maybe<any>, topImage?: Maybe<SanityCustomImageFragment>, bottomImage?: Maybe<SanityCustomImageFragment> }> };

export type AllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsQuery = { allPostTag: Array<TagsPostDataFragment> };

export type BlogFeaturedPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogFeaturedPostsQuery = { allMainBlogPage: Array<{ featuredPosts?: Maybe<Array<Maybe<FeaturedPostDataFragment>>> }> };

export type MainImageUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type MainImageUrlQuery = { allHomepage: Array<{ desktopImage?: Maybe<{ asset?: Maybe<{ url?: Maybe<string> }> }> }> };

export type CategoryPostQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type CategoryPostQuery = { allPost: Array<(
    { slug?: Maybe<{ current?: Maybe<string> }> }
    & PostDataFragment
  )> };

export type CategoryQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CategoryQuery = { allPostCategory: Array<{ title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> }> };

export type AllAboutMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAboutMeQuery = { allHomepage: Array<{ aboutMeContentRaw?: Maybe<any>, aboutMeImage?: Maybe<SanityCustomImageFragment> }> };

export type AllHomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type AllHomepageQuery = { allHomepage: Array<{ categoryOrder?: Maybe<Array<Maybe<{ slug?: Maybe<{ current?: Maybe<string> }> }>>>, desktopImage?: Maybe<SanityCustomImageFragment>, mobileImage?: Maybe<SanityCustomImageFragment>, topCta?: Maybe<CtaFragment>, bottomCta?: Maybe<CtaFragment>, featuredPosts?: Maybe<Array<Maybe<{ _id?: Maybe<string> }>>> }> };

export type CtaFragment = { title?: Maybe<string>, subtitle?: Maybe<string>, buttonText?: Maybe<string>, backgroundImage?: Maybe<SanityMinimalImageFragment>, backgroundImageMobile?: Maybe<SanityMinimalImageFragment>, link?: Maybe<{ __typename: 'Gallery', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'MyProjects', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'Post', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'Services', slug?: Maybe<{ current?: Maybe<string> }> }> };

export type SanityMinimalImageFragment = { alt?: Maybe<string>, asset?: Maybe<{ url?: Maybe<string>, metadata?: Maybe<{ lqip?: Maybe<string>, dimensions?: Maybe<{ width?: Maybe<number>, height?: Maybe<number>, aspectRatio?: Maybe<number> }> }> }> };

export type ProjectsSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsSlugsQuery = { allMyProjectsConfig: Array<{ navigation?: Maybe<Array<Maybe<{ _type?: Maybe<string>, link?: Maybe<{ _type?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> } | { _type?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> }> }>>> }> };

export type ProjectConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectConfigQuery = { allMyProjectsConfig: Array<{ _id?: Maybe<string>, navigation?: Maybe<Array<Maybe<{ link?: Maybe<ProjectGalleryFragment | MyProjectFragment> }>>> }> };

export type ProjectGalleryFragment = { __typename: 'Gallery', title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }>, images?: Maybe<Array<Maybe<{ title?: Maybe<string>, thumbnail?: Maybe<SanityMinimalImageFragment>, images?: Maybe<Array<Maybe<SanityCustomImageFragment>>> }>>> };

export type ProjectQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ProjectQuery = { allMyProjects: Array<MyProjectFragment> };

export type MyProjectFragment = { __typename: 'MyProjects', title?: Maybe<string>, topTextRaw?: Maybe<any>, middleTopTextRaw?: Maybe<any>, middleBottomTextRaw?: Maybe<any>, bottomTextRaw?: Maybe<any>, slug?: Maybe<{ current?: Maybe<string> }>, properties?: Maybe<Array<Maybe<{ key?: Maybe<string>, value?: Maybe<string> }>>>, topImage?: Maybe<SanityMinimalImageFragment>, middleTopImage?: Maybe<SanityMinimalImageFragment>, middleBottomImage?: Maybe<SanityMinimalImageFragment>, imagesRow?: Maybe<Array<Maybe<SanityMinimalImageFragment>>>, gallery?: Maybe<Array<Maybe<SanityMinimalImageFragment>>> };

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = { allServices: Array<{ slug?: Maybe<{ current?: Maybe<string> }> }> };

export type ServiceQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type ServiceQuery = { allServices: Array<{ title?: Maybe<string>, topTextRaw?: Maybe<any>, middleTextRaw?: Maybe<any>, slug?: Maybe<{ current?: Maybe<string> }>, mainImage?: Maybe<SanityMinimalImageFragment>, mainImageMobile?: Maybe<SanityMinimalImageFragment>, serviceItems?: Maybe<Array<Maybe<{ title?: Maybe<string>, subtitle?: Maybe<string>, _key?: Maybe<string>, backgroundImage?: Maybe<SanityMinimalImageFragment> }>>>, button?: Maybe<ButtonFragment> }> };

export type ButtonFragment = { text?: Maybe<string>, mobileText?: Maybe<string>, linkType?: Maybe<string>, externalLink?: Maybe<string>, link?: Maybe<{ __typename: 'AboutMe', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'Gallery', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'Homepage' } | { __typename: 'MainBlogPage' } | { __typename: 'MyProjects', slug?: Maybe<{ current?: Maybe<string> }> } | { __typename: 'Post', slug?: Maybe<{ current?: Maybe<string> }> }> };

export type SanityCustomImageFragment = { alt?: Maybe<string>, caption?: Maybe<string>, asset?: Maybe<{ url?: Maybe<string>, metadata?: Maybe<{ lqip?: Maybe<string>, dimensions?: Maybe<{ width?: Maybe<number>, height?: Maybe<number> }> }> }> };

export type AllPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPostsQuery = { allPost: Array<{ _id?: Maybe<string>, title?: Maybe<string>, date?: Maybe<string>, description?: Maybe<string>, summary?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }>, mainPhoto?: Maybe<SanityCustomImageFragment>, category?: Maybe<{ title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> }> }> };

export type PostDataFragment = { title?: Maybe<string>, description?: Maybe<string>, date?: Maybe<string>, postContentRaw?: Maybe<any>, mainPhoto?: Maybe<{ asset?: Maybe<{ url?: Maybe<string>, metadata?: Maybe<{ lqip?: Maybe<string> }> }> }> };

export type FeaturedPostDataFragment = { _id?: Maybe<string>, title?: Maybe<string>, date?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }>, mainPhoto?: Maybe<{ crop?: Maybe<{ bottom?: Maybe<number>, left?: Maybe<number>, right?: Maybe<number>, top?: Maybe<number> }>, hotspot?: Maybe<{ x?: Maybe<number>, y?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number> }>, asset?: Maybe<{ url?: Maybe<string>, metadata?: Maybe<{ lqip?: Maybe<string> }> }> }> };

export type TagsPostDataFragment = { _id?: Maybe<string>, title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> };

export type CurrentPostQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type CurrentPostQuery = { allPost: Array<(
    { tags?: Maybe<Array<Maybe<TagsPostDataFragment>>>, featuredPosts?: Maybe<Array<Maybe<FeaturedPostDataFragment>>>, category?: Maybe<{ slug?: Maybe<{ current?: Maybe<string> }> }> }
    & PostDataFragment
  )> };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { allPostCategory: Array<{ title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> }> };

export type SearchPostQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchPostQuery = { allPost: Array<(
    { slug?: Maybe<{ current?: Maybe<string> }> }
    & PostDataFragment
  )> };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { allPostTag: Array<{ slug?: Maybe<{ current?: Maybe<string> }> }> };

export type TagQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type TagQuery = { allPostTag: Array<{ title?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }> }> };

export type AllPostsTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPostsTagsQuery = { allPost: Array<(
    { _id?: Maybe<string>, slug?: Maybe<{ current?: Maybe<string> }>, tags?: Maybe<Array<Maybe<{ slug?: Maybe<{ current?: Maybe<string> }> }>>> }
    & PostDataFragment
  )> };

export const SanityMinimalImageFragmentDoc = gql`
    fragment SanityMinimalImage on MinimalImage {
  asset {
    url
    metadata {
      lqip
      dimensions {
        width
        height
        aspectRatio
      }
    }
  }
  alt
}
    `;
export const CtaFragmentDoc = gql`
    fragment CTA on Cta {
  title
  subtitle
  backgroundImage {
    ...SanityMinimalImage
  }
  backgroundImageMobile {
    ...SanityMinimalImage
  }
  buttonText
  link {
    __typename
    ... on Services {
      slug {
        current
      }
    }
    ... on MyProjects {
      slug {
        current
      }
    }
    ... on Gallery {
      slug {
        current
      }
    }
    ... on Post {
      slug {
        current
      }
    }
  }
}
    ${SanityMinimalImageFragmentDoc}`;
export const SanityCustomImageFragmentDoc = gql`
    fragment SanityCustomImage on MyImage {
  asset {
    url
    metadata {
      lqip
      dimensions {
        width
        height
      }
    }
  }
  alt
  caption
}
    `;
export const ProjectGalleryFragmentDoc = gql`
    fragment ProjectGallery on Gallery {
  __typename
  title
  slug {
    current
  }
  images {
    title
    thumbnail {
      ...SanityMinimalImage
    }
    images {
      ...SanityCustomImage
    }
  }
}
    ${SanityMinimalImageFragmentDoc}
${SanityCustomImageFragmentDoc}`;
export const MyProjectFragmentDoc = gql`
    fragment MyProject on MyProjects {
  __typename
  title
  slug {
    current
  }
  topTextRaw
  properties {
    key
    value
  }
  topImage {
    ...SanityMinimalImage
  }
  middleTopTextRaw
  middleBottomTextRaw
  middleTopImage {
    ...SanityMinimalImage
  }
  middleBottomImage {
    ...SanityMinimalImage
  }
  imagesRow {
    ...SanityMinimalImage
  }
  bottomTextRaw
  gallery {
    ...SanityMinimalImage
  }
}
    ${SanityMinimalImageFragmentDoc}`;
export const ButtonFragmentDoc = gql`
    fragment Button on Button {
  text
  mobileText
  link {
    __typename
    ... on AboutMe {
      slug {
        current
      }
    }
    ... on Post {
      slug {
        current
      }
    }
    ... on MyProjects {
      slug {
        current
      }
    }
    ... on Gallery {
      slug {
        current
      }
    }
    ... on Post {
      slug {
        current
      }
    }
  }
  linkType
  externalLink
}
    `;
export const PostDataFragmentDoc = gql`
    fragment PostData on Post {
  title
  description
  date
  mainPhoto {
    asset {
      url
      metadata {
        lqip
      }
    }
  }
  postContentRaw
}
    `;
export const FeaturedPostDataFragmentDoc = gql`
    fragment FeaturedPostData on Post {
  _id
  slug {
    current
  }
  mainPhoto {
    crop {
      bottom
      left
      right
      top
    }
    hotspot {
      x
      y
      width
      height
    }
    asset {
      url
      metadata {
        lqip
      }
    }
  }
  title
  date
}
    `;
export const TagsPostDataFragmentDoc = gql`
    fragment TagsPostData on PostTag {
  _id
  title
  slug {
    current
  }
}
    `;
export const AllAboutDocument = gql`
    query allAbout {
  allAboutMe(limit: 1) {
    aboutMeTopContentRaw
    topImage {
      ...SanityCustomImage
    }
    aboutMeQuoteRaw
    aboutMeBottomContentRaw
    bottomImage {
      ...SanityCustomImage
    }
  }
}
    ${SanityCustomImageFragmentDoc}`;
export const AllTagsDocument = gql`
    query allTags {
  allPostTag {
    ...TagsPostData
  }
}
    ${TagsPostDataFragmentDoc}`;
export const BlogFeaturedPostsDocument = gql`
    query blogFeaturedPosts {
  allMainBlogPage {
    featuredPosts {
      ...FeaturedPostData
    }
  }
}
    ${FeaturedPostDataFragmentDoc}`;
export const MainImageUrlDocument = gql`
    query mainImageUrl {
  allHomepage(where: {_: {is_draft: false}}, limit: 1) {
    desktopImage {
      asset {
        url
      }
    }
  }
}
    `;
export const CategoryPostDocument = gql`
    query CategoryPost($category: String!) {
  allPost(
    where: {category: {slug: {current: {eq: $category}}}, _: {is_draft: false}}
  ) {
    ...PostData
    slug {
      current
    }
  }
}
    ${PostDataFragmentDoc}`;
export const CategoryDocument = gql`
    query Category($slug: String!) {
  allPostCategory(where: {slug: {current: {eq: $slug}}}) {
    title
    slug {
      current
    }
  }
}
    `;
export const AllAboutMeDocument = gql`
    query allAboutMe {
  allHomepage(limit: 1) {
    aboutMeContentRaw
    aboutMeImage {
      ...SanityCustomImage
    }
  }
}
    ${SanityCustomImageFragmentDoc}`;
export const AllHomepageDocument = gql`
    query allHomepage {
  allHomepage(where: {_: {is_draft: false}}, limit: 1) {
    categoryOrder {
      slug {
        current
      }
    }
    desktopImage {
      ...SanityCustomImage
    }
    mobileImage {
      ...SanityCustomImage
    }
    topCta {
      ...CTA
    }
    bottomCta {
      ...CTA
    }
    featuredPosts {
      _id
    }
  }
}
    ${SanityCustomImageFragmentDoc}
${CtaFragmentDoc}`;
export const ProjectsSlugsDocument = gql`
    query ProjectsSlugs {
  allMyProjectsConfig {
    navigation {
      _type
      link {
        ... on MyProjects {
          _type
          slug {
            current
          }
        }
        ... on Gallery {
          _type
          slug {
            current
          }
        }
      }
    }
  }
}
    `;
export const ProjectConfigDocument = gql`
    query ProjectConfig {
  allMyProjectsConfig(limit: 1) {
    _id
    navigation {
      link {
        ... on MyProjects {
          ...MyProject
        }
        ... on Gallery {
          ...ProjectGallery
        }
      }
    }
  }
}
    ${MyProjectFragmentDoc}
${ProjectGalleryFragmentDoc}`;
export const ProjectDocument = gql`
    query Project($slug: String!) {
  allMyProjects(where: {slug: {current: {eq: $slug}}}) {
    ...MyProject
  }
}
    ${MyProjectFragmentDoc}`;
export const ServicesDocument = gql`
    query Services {
  allServices {
    slug {
      current
    }
  }
}
    `;
export const ServiceDocument = gql`
    query Service($slug: String) {
  allServices(where: {slug: {current: {eq: $slug}}, _: {is_draft: false}}) {
    title
    slug {
      current
    }
    topTextRaw
    mainImage {
      ...SanityMinimalImage
    }
    mainImageMobile {
      ...SanityMinimalImage
    }
    middleTextRaw
    serviceItems {
      title
      subtitle
      _key
      backgroundImage {
        ...SanityMinimalImage
      }
    }
    button {
      ...Button
    }
  }
}
    ${SanityMinimalImageFragmentDoc}
${ButtonFragmentDoc}`;
export const AllPostsDocument = gql`
    query allPosts {
  allPost(where: {_: {is_draft: false}}, sort: {date: DESC}) {
    _id
    title
    date
    description
    summary
    slug {
      current
    }
    mainPhoto {
      ...SanityCustomImage
    }
    category {
      title
      slug {
        current
      }
    }
  }
}
    ${SanityCustomImageFragmentDoc}`;
export const CurrentPostDocument = gql`
    query currentPost($slug: String) {
  allPost(where: {slug: {current: {eq: $slug}}, _: {is_draft: false}}) {
    tags {
      ...TagsPostData
    }
    featuredPosts {
      ...FeaturedPostData
    }
    category {
      slug {
        current
      }
    }
    ...PostData
  }
}
    ${TagsPostDataFragmentDoc}
${FeaturedPostDataFragmentDoc}
${PostDataFragmentDoc}`;
export const CategoriesDocument = gql`
    query Categories {
  allPostCategory(where: {_: {is_draft: false}}) {
    slug {
      current
    }
    title
  }
}
    `;
export const SearchPostDocument = gql`
    query SearchPost {
  allPost(where: {_: {is_draft: false}}) {
    ...PostData
    slug {
      current
    }
  }
}
    ${PostDataFragmentDoc}`;
export const TagsDocument = gql`
    query Tags {
  allPostTag(where: {_: {is_draft: false}}) {
    slug {
      current
    }
  }
}
    `;
export const TagDocument = gql`
    query Tag($slug: String!) {
  allPostTag(where: {slug: {current: {eq: $slug}}}) {
    title
    slug {
      current
    }
  }
}
    `;
export const AllPostsTagsDocument = gql`
    query allPostsTags {
  allPost(where: {_: {is_draft: false}}) {
    _id
    slug {
      current
    }
    tags {
      slug {
        current
      }
    }
    ...PostData
  }
}
    ${PostDataFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    allAbout(variables?: AllAboutQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllAboutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllAboutQuery>(AllAboutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allAbout');
    },
    allTags(variables?: AllTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllTagsQuery>(AllTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allTags');
    },
    blogFeaturedPosts(variables?: BlogFeaturedPostsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BlogFeaturedPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogFeaturedPostsQuery>(BlogFeaturedPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'blogFeaturedPosts');
    },
    mainImageUrl(variables?: MainImageUrlQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MainImageUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MainImageUrlQuery>(MainImageUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mainImageUrl');
    },
    CategoryPost(variables: CategoryPostQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CategoryPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryPostQuery>(CategoryPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CategoryPost');
    },
    Category(variables: CategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryQuery>(CategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Category');
    },
    allAboutMe(variables?: AllAboutMeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllAboutMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllAboutMeQuery>(AllAboutMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allAboutMe');
    },
    allHomepage(variables?: AllHomepageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllHomepageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllHomepageQuery>(AllHomepageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allHomepage');
    },
    ProjectsSlugs(variables?: ProjectsSlugsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProjectsSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProjectsSlugsQuery>(ProjectsSlugsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProjectsSlugs');
    },
    ProjectConfig(variables?: ProjectConfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProjectConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProjectConfigQuery>(ProjectConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProjectConfig');
    },
    Project(variables: ProjectQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProjectQuery>(ProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Project');
    },
    Services(variables?: ServicesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesQuery>(ServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Services');
    },
    Service(variables?: ServiceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ServiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceQuery>(ServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Service');
    },
    allPosts(variables?: AllPostsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPostsQuery>(AllPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allPosts');
    },
    currentPost(variables?: CurrentPostQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentPostQuery>(CurrentPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentPost');
    },
    Categories(variables?: CategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoriesQuery>(CategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Categories');
    },
    SearchPost(variables?: SearchPostQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchPostQuery>(SearchPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchPost');
    },
    Tags(variables?: TagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagsQuery>(TagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Tags');
    },
    Tag(variables: TagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagQuery>(TagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Tag');
    },
    allPostsTags(variables?: AllPostsTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllPostsTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPostsTagsQuery>(AllPostsTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allPostsTags');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;